"use strict";
/** *******************************************************************************************************************
  Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
  
  Licensed under the Apache License, Version 2.0 (the "License").
  You may not use this file except in compliance with the License.
  You may obtain a copy of the License at
  
      http://www.apache.org/licenses/LICENSE-2.0
  
  Unless required by applicable law or agreed to in writing, software
  distributed under the License is distributed on an "AS IS" BASIS,
  WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
  See the License for the specific language governing permissions and
  limitations under the License.                                                                              *
 ******************************************************************************************************************** */
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const clsx_1 = __importDefault(require("clsx"));
const styles_1 = require("@material-ui/core/styles");
const core_1 = require("@material-ui/core");
const Container_1 = __importDefault(require("../../layouts/Container"));
const useStyles = styles_1.makeStyles((theme) => ({
    tab: {
        marginRight: '-1px',
        borderRight: `1px solid ${theme.palette.grey[400]}`,
        padding: '5px 20px',
        '&:last-child': {
            borderRight: 'none',
        },
    },
    noBorder: {
        '& .MuiTabs-scroller': {
            borderBottom: 'none',
        },
    },
}));
function TabPanel(props) {
    const { children, value, index } = props;
    return (react_1.default.createElement(core_1.Typography, { component: "div", role: "tabpanel", hidden: value !== index, id: `tabpanel-${index}` },
        react_1.default.createElement(core_1.Box, { py: 3 }, children)));
}
/**
 * Use tabs for organizing discrete blocks of information.
 */
const Tabs = ({ tabs, activeId = '', variant = 'default', onChange }) => {
    const classes = useStyles({});
    const tabIndex = tabs.findIndex((tab) => tab.id === activeId);
    const [value, setValue] = react_1.default.useState(tabIndex === -1 ? 0 : tabIndex);
    const handleChange = (event, index) => {
        onChange === null || onChange === void 0 ? void 0 : onChange(tabs[index].id);
        setValue(index);
    };
    const headerContent = (react_1.default.createElement(core_1.Tabs, { variant: "scrollable", indicatorColor: "secondary", TabIndicatorProps: { color: 'primary' }, value: value, onChange: handleChange, className: clsx_1.default({ [classes.noBorder]: variant === 'container' }) }, tabs.map((tab) => (react_1.default.createElement(core_1.Tab, { key: tab.id, className: classes.tab, label: tab.label, disabled: tab.disabled })))));
    const tabContent = tabs.map((tab, idx) => (react_1.default.createElement(TabPanel, { key: tab.id, value: value, index: idx }, tab.content)));
    return variant === 'container' ? (react_1.default.createElement(Container_1.default, { headerContent: headerContent, headerGutters: false }, tabContent)) : (react_1.default.createElement(react_1.default.Fragment, null,
        headerContent,
        tabContent));
};
exports.default = Tabs;
//# sourceMappingURL=index.js.map